// Tavern room: renders the floor and walls using the PixelLab Wang tileset.
// Falls back to a graphics-drawn room if the tileset hasn't loaded yet.
import { PALETTE as C } from "./palette.js";
import { registerWangFrames, paintTerrain } from "./wang.js";

export const TILE = 32;
export const ROOM_COLS = 20;
export const ROOM_ROWS = 13;
export const ROOM_W = ROOM_COLS * TILE;
export const ROOM_H = ROOM_ROWS * TILE;

// Terrain: walls ("upper") on the outer one-tile border, floor ("lower") inside.
// Carve a doorway on the bottom wall and a window (visual only) on the top.
function defaultTerrain(vx, vy) {
  // Door at bottom: vertices (15..17, ROOM_ROWS-1..ROOM_ROWS) are lower so
  // the tile selection breaks the wall into an archway.
  const atDoor = (vy === ROOM_ROWS || vy === ROOM_ROWS - 1) && vx >= 15 && vx <= 17;
  if (atDoor) return "lower";

  if (vx === 0 || vx === ROOM_COLS || vy === 0 || vy === ROOM_ROWS) return "upper";
  return "lower";
}

export function drawRoom(scene) {
  const collisions = [];

  const hasTileset = scene.textures.exists("tileset") && scene.cache.json.has("tileset_json");

  if (hasTileset) {
    const metadata = scene.cache.json.get("tileset_json");
    const cornerMap = registerWangFrames(scene, "tileset", metadata);
    paintTerrain(scene, "tileset", cornerMap, ROOM_COLS, ROOM_ROWS, TILE, defaultTerrain);
  } else {
    // Graphics fallback -- matches the palette so the room reads as a room.
    const g = scene.add.graphics();
    g.fillStyle(C.wood, 1);
    g.fillRect(0, 0, ROOM_W, ROOM_H);
    g.fillStyle(C.stone, 1);
    g.fillRect(0, 0, ROOM_W, TILE);
    g.fillRect(0, 0, TILE, ROOM_H);
    g.fillRect(ROOM_W - TILE, 0, TILE, ROOM_H);
    g.fillRect(0, ROOM_H - TILE, ROOM_W, TILE);
  }

  // Wall collisions on the outer border, minus the doorway.
  collisions.push({ x: 0, y: 0, w: ROOM_W, h: TILE }); // top
  collisions.push({ x: 0, y: 0, w: TILE, h: ROOM_H }); // left
  collisions.push({ x: ROOM_W - TILE, y: 0, w: TILE, h: ROOM_H }); // right
  // Bottom: two segments to leave a doorway.
  collisions.push({ x: 0, y: ROOM_H - TILE, w: 15 * TILE, h: TILE });
  collisions.push({ x: 17 * TILE, y: ROOM_H - TILE, w: (ROOM_COLS - 17) * TILE, h: TILE });

  return collisions;
}
